<div class="header-content">
  <ng-content />
</div>

<mat-divider class="header-line-filler" />
